import { render } from "./App.vue?vue&type=template&id=16dd2a9f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=16dd2a9f&lang=css"

import exportComponent from "/Users/chichchic/code/simple-client-deployment/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__